import { FC } from 'react'
import { getCurrentDate } from 'shared/utils/getCurrentDate'
import { getInternalServerErrorMessage } from 'shared/utils/getResponseErrorMessage'

// 401
export const UnauthorizedDescription = () => {
    return (
        <>
            Устаревшие данные для входа. Просьба авторизоваться повторно. <br />
            Текущее время: {getCurrentDate()}
        </>
    )
}

// 403
export const ForbiddenDescription = () => {
    return (
        <>
            Отказано в доступе. <br />
            Текущее время: {getCurrentDate()}
        </>
    )
}

// 404
export const NotFoundDescription = () => {
    return (
        <>
            Страница не найдена. <br />
            Текущее время: {getCurrentDate()}
        </>
    )
}

// 500
export const InternalServerErrorDescription = () => {
    return (
        <>
            Внутренняя ошибка сервера. <br />
            Текущее время: {getCurrentDate()}
        </>
    )
}

interface InternalServerErrorProps {
    errorMessage: string
}

// 500 with message
export const InternalServerErrorDescriptionWithMessage: FC<InternalServerErrorProps> = ({
    errorMessage
}) => {
    return (
        <>
            {getInternalServerErrorMessage(errorMessage)}. <br />
            Текущее время: {getCurrentDate()}
        </>
    )
}
